import { Message } from '../types/message';

export function generateSeparator(chatId: number, text: string): Message {
  let date = new Date().toISOString();
  return {
    impersonate: null,
    chatId,
    localId: null,
    id: 0 + Math.random(),
    userId: '',
    type: 'system',
    createdAt: date,
    updatedAt: date,
    meanings: ['separator'],
    text,
    showUserInfo: false,
    messageQuoteId: null,
    image: null,
    extra_data: null,
  };
}
